import ApplicationController from "./application_controller";
import Rails from "@rails/ujs";
import StimulusReflex from "stimulus_reflex";
export default class extends ApplicationController {
  static targets = ["hm0_output"];

  connect() {
    console.log("Cra mensuel JS en cours ...");
    super.connect();
    if ($("#search").length && $("#quick_sort").length) {
      //on est sur la vue list
      //this.show_edition_multiple();
      this.rerender();
      (function ($) {
        $.each(["show", "hide"], function (i, ev) {
          var el = $.fn[ev];
          $.fn[ev] = function () {
            this.trigger(ev);
            return el.apply(this, arguments);
          };
        });
      })(jQuery);
      $("#spinner").on("show", function () {
        $("#total_entries").hide();
      });
      $("#spinner").on("hide", function () {
        $("#total_entries").show();
      });
    }
    MicroModal.init();
    this.handleSidebarScroll("cra_mensuel_");

  }

  show_edition_multiple() {
    if (this.current_app && this.params) {
      let url =
        window.location.origin +
        "/" +
        this.current_app +
        "/cra_mensuels/show_ajax_edition_multiple?filtrage=" +
        this.params +
        "&vr2=1";
      fetch(url).then((response) =>
        response.text().then(function (text) {
          $("#edition_multiple").html("");
          $("#edition_multiple").html(text);
          MicroModal.init();
        })
      );
    }
  }




  quick_cra_normal_recalc(event) {
    this.stimulate("CraMensuels#quick_cra_normal_recalc", event.currentTarget);
  }
  etaler_temps(event) {
    let imput_id_model = $('#target_temps').val();
    let time_value = $("#quantite").val();
    let element_to_fire;
    let elements_to_fill = $("[id^='remplir_ts']");
    elements_to_fill.each(function (index) {
      if (elements_to_fill[index].value == "1") {
        var id_contsruct = elements_to_fill[index].id.split("remplir_")[1]
        id_contsruct = id_contsruct + imput_id_model;
        var elements = $("[id^='" + id_contsruct + "']");
        elements.each(async function (i) {
          if ((!elements[i].id.includes("commentaires")) && (elements[i].type != "hidden") && (!elements[i].closest("td").getAttribute("style").includes('background-color') || (elements[i].closest("td").getAttribute("style").includes('background-color') && elements[i].closest("td").getAttribute("style").includes('orange')))) {
            elements[i].value = time_value;
            element_to_fire = elements[i];
            element_to_fire.dispatchEvent(new Event("input"));
            await new Promise(r => setTimeout(r, 100));
          }
        });
      }
    });
    MicroModal.close("etaler_temps");
  }

  search(event) {
    var table_id = event.target.dataset.table_id;
    var input_id = event.target.dataset.input_id;
    var input, filter, table, tr, td, i, txtValue, label;
    input = document.getElementById(input_id);
    filter = input.value.toUpperCase();
    table = document.getElementById(table_id);
    tr = table.getElementsByTagName("tr");
    for (i = 0; i < tr.length; i++) {
      td = tr[i].getElementsByTagName("td")[0];
      label = td.getElementsByTagName("label")[0];
      if (label) {
        txtValue = td.textContent || td.innerText;
        if (txtValue.toUpperCase().indexOf(filter) > -1) {
          tr[i].style.display = "";
        } else {
          tr[i].style.display = "none";
        }
      }
    }
  }

  hide_show_all(event) {
    var crs_ids = eval(event.target.dataset.crs_ids);
    var doms_crs_ids = eval(event.target.dataset.doms_crs_ids);
    var act_ids = eval(event.target.dataset.act_ids);
    var self = this;
    for (let i = 0; i < crs_ids.length; i++) {
      setTimeout(function () { self.check_uncheck(crs_ids[i], 'crs', null, 1), 100 });
    }
    for (let i = 0; i < doms_crs_ids.length; i++) {
      setTimeout(function () { self.check_uncheck(doms_crs_ids[i][0], 'dom', doms_crs_ids[i][1], 1), 100 });
    }
    for (let i = 0; i < act_ids.length; i++) {
      setTimeout(function () { self.check_uncheck(act_ids[i], 'act', null, 1), 100 });
    }
    var element_to_fire = $("#quick_cra input[data-action][id*='ts']").first();
    if (element_to_fire.length > 0) {
      element_to_fire[0].dispatchEvent(new Event("input"));
    } else {
      this.stimulate("CraMensuels#quick_cra_normal_recalc", event.currentTarget);
    }
  }

  check_uncheck(id, type, id_bis = null, all = null) {
    if (type == 'crs') {
      var val = $("#check_crs_" + id).prop('checked');
      if (!val) {
        $("#check_crs_" + id).click();
      }
    }
    if (type == "dom") {
      var val = $("#check_crs_" + id + "_dom_" + id_bis).prop("checked");
      $("#check_crs_" + id).prop("checked", true);
      if (!val) {
        $("#check_crs_" + id + "_dom_" + id_bis).click();
      }
    }
    if (type == "act") {
      var val = $("#check_act_" + id).prop('checked');
      if (!val) {
        $("#check_act_" + id).click();
      }
    }
  }

  hide_show(event) {
    var id = event.target.dataset.id
    var type = event.target.dataset.type
    var id_bis = event.target.dataset.id_bis
    var all = event.target.dataset.all
    if (type == 'crs') {
      var elements = $("[id$='_" + id + "'][id^='tsid']")
      if (elements.is(":visible")) {
        elements.toggle('slow');
      } else {
        elements.toggle('slow');
      }
    }
    if (type == "dom") {
      var elements = $("[id$='_" + id + "_dom_" + id_bis + "'][id^='tsid']")
      var parent_element = $("[id$='tsid_" + id + "'][id^='tsid']")
      if (elements.is(":visible")) {
        elements.toggle('slow');
      } else {
        elements.toggle('slow');
        parent_element.show();
        $("#check_crs_" + id).prop('checked', true);
      }
      setTimeout(function () {
        var all_elements_visible = $("[id^='tsid_" + id + "_dom_']").is(":visible")
        console.log(all_elements_visible)
        if (all_elements_visible) {
          parent_element.show();
          $("#check_crs_" + id).prop('checked', true);
        } else {
          parent_element.hide();
          $("#check_crs_" + id).prop('checked', false);
        }
      }, 900);

    }
    if (type == "act") {
      elements = $("[id$='_" + id + "_act_type'][id^='tsid']")
      if (elements.is(":visible")) {
        elements.toggle('slow');
      } else {
        elements.toggle('slow');
      }
    }
    if (!all) {
      $("tr[style*='background-color: rgb(255, 255, 204)']").css("background", "none");
      elements.css("background-color", "rgb(255, 255, 204)");
    }
    //setTimeout(function(){ elements.css("background","none")},3500);
  }
  scrolleft(event) {
    event.preventDefault();
    var pos = $('#container_cra').scrollLeft();
    pos = pos - 400;
    $('#container_cra').scrollLeft(pos);
  }
  scrolright(event) {
    event.preventDefault();
    var pos = $('#container_cra').scrollLeft();
    pos = pos + 400;
    $('#container_cra').scrollLeft(pos);
  }

  checkAll(event) {
    var crs_id = event.target.dataset.crs_id
    var checkboxes = $("[id^='checkbox_" + crs_id + "']");
    var inputs = $("[id^='remplir_" + crs_id + "']");
    checkboxes.prop('checked', true);
    inputs.val('1');
  }
  uncheckAll(event) {
    var crs_id = event.target.dataset.crs_id
    var checkboxes = $("[id^='checkbox_" + crs_id + "']");
    var inputs = $("[id^='remplir_" + crs_id + "']");
    checkboxes.prop('checked', false);
    inputs.val('');
  }

  updateValue(event) {
    var id = event.target.dataset.id
    if ($("#checkbox_" + id).prop('checked')) {
      $("#remplir_" + id).val(1);
    } else {
      $("#remplir_" + id).val('');
    }
  }
  update_transfert(event) {
    this.stimulate("CraMensuels#updateTransfert", event.currentTarget);
  }
  refresh_pref(event) {
    var loader = document.getElementsByClassName("child-loader")[0]
    var elem = document.getElementById("cra_mensuels");
    elem.innerHTML = loader.innerHTML;
    this.stimulate("CraMensuels#refresh_pref", event.currentTarget);
  }
  fusion_ligne_domaine(event) {
    var loader = document.getElementsByClassName("child-loader")[0]
    var elem = document.getElementById("cra_mensuels");
    elem.innerHTML = loader.innerHTML;
    this.stimulate("CraMensuels#fusion_ligne_domaine", event.currentTarget);
  }
  pre_remplir_cra(event) {
    var loader = document.getElementsByClassName("child-loader")[0]
    var elem = document.getElementById("cra_mensuels");
    elem.innerHTML = loader.innerHTML;
    this.stimulate("CraMensuels#pre_remplir_cra", event.currentTarget);
  }
  beforePreRemplirCra(element) {
    var elem = document.getElementById("cra_mensuels");
    elem.setAttribute("style", "padding-top:200px;text-align:center");
    console.log("GO");
  }
  afterPreRemplirCra(element) {
    var elem = document.getElementById("cra_mensuels");
    elem.setAttribute("style", "");
    console.log("FINI");
  }
  beforeRefreshPref(element) {
    var elem = document.getElementById("cra_mensuels");
    elem.setAttribute("style", "padding-top:200px;text-align:center");
    console.log("GO");
  }
  afterRefreshPref(element) {
    var elem = document.getElementById("cra_mensuels");
    elem.setAttribute("style", "");
    $('#change_checkbox').prop('checked', !$('#change_checkbox').prop('checked'));
    $("#edit_button").show();
    console.log("FINI");
  }
  beforeFusionLigneDomaine(element) {
    var elem = document.getElementById("cra_mensuels");
    elem.setAttribute("style", "padding-top:200px;text-align:center");
    console.log("GO");
  }
  afterFusionLigneDomaine(element) {
    var elem = document.getElementById("cra_mensuels");
    elem.setAttribute("style", "");
    $("#edit_button").show();
    console.log("FINI");
  }
  get params() {
    return this.data.get("params");
  }

  get entreprise_ids() {
    return this.data.get("entrepriseids");
  }

  get entreprise_id() {
    return this.data.get("entrepriseid");
  }

  get current_app() {
    return this.data.get("app");
  }

  get url_solution() {
    return this.data.get("urlsolution");
  }

  quickCraNormalRecalcSuccess(element) {
    if (document.getElementById("scrollevel_div")) {
      document.getElementById("container_cra").scrollLeft =
        document.getElementById("scrollevel_div").value;
    }
    // this.documentIsCrolled_()
  }
  getCurrentHeight(ids) {
    let height = 0;
    for (var i = 0; i < ids.length; i++) {
      if (document.getElementById(ids[i])) {
        height = height + document.getElementById(ids[i]).offsetHeight;
      }
    }
    return height;
  }

  beforeReflex(element, reflex, noop, reflexId) {
    console.log("before reflex callback in stimulus");
    if ($(".content-search")) {
      $(".content-search").select2({
        width: "resolve",
        placeholder: "",
        allowClear: true
      });
    }
    MicroModal.init();
    this.changeColor();
  }
  afterReflex(element, reflex, noop, reflexId) {
    console.log("After reflex callback in stimulus");
    if ($(".content-search")) {
      $(".content-search").select2({
        width: "resolve",
        placeholder: "",
        allowClear: true
      });
    }
    MicroModal.init();
    this.changeColor();
  }
  // Save a reference to the element that should receive focus
  reflexSuccess(element, reflex, noop, reflexId) {
    console.log("success reflex callback in stimulus");
    if ($(".content-search")) {
      $(".content-search").select2({
        width: "resolve",
        placeholder: "",
        allowClear: true
      });
    }
    MicroModal.init();
    this.changeColor();
  }

  reflexError(element, reflex, error, reflexId) {
    console.log("Error reflex callback in stimulus");
    if ($(".content-search")) {
      $(".content-search").select2({
        width: "resolve",
        placeholder: "",
        allowClear: true
      });
    }
    MicroModal.init();
    this.changeColor();
  }
  documentIsCrolled_() {
    //Récupération des éléments html qu'on aimerait manipuler par le biais de leur ID
    let sticky = navbar.offsetTop;
    let simple_compotor = document.getElementById("simple_compotor");
    let fieldsets_section = document.getElementById("fieldsets_section");
    let field_section_28985 = document.getElementById("field_section_28985");
    if (window.pageYOffset >= sticky) {
      if (simple_compotor) {
        simple_compotor.style.padding = "10px";
        simple_compotor.style.marginLeft = "0px";
        simple_compotor.style.marginTop = "0";
        simple_compotor.style.backgroundColor = "white";
        simple_compotor.style.left = 0;
        simple_compotor.classList.add("sticky");
        simple_compotor.style.zIndex = "5";
      }
      if (fieldsets_section) {
        fieldsets_section.classList.add("sticky");
        fieldsets_section.style.left = 0;
        fieldsets_section.style.top =
          this.getCurrentHeight(["simple_compotor"]) - 7 + "px";
        fieldsets_section.style.backgroundColor = "white";
        fieldsets_section.style.zIndex = "5";
        fieldsets_section.style.paddingBottom = "15px";

        if (field_section_28985) {
          field_section_28985.style.marginBottom =
            this.getCurrentHeight(["fieldsets_section"]) - 90 + "px";
        }
      }
      // if (container_cra) {
      //   container_cra.classList.add("tableFixHead");
      //   container_cra.style.borderCollapse = "initial";
      //   container_cra.style.top =
      //     getCurrentHeight(["fieldsets_section"]) - 180 + "px";
      //   container_cra.style.zIndex = "5";
      // }
    } else {
      if (simple_compotor) {
        simple_compotor.classList.remove("sticky");
        simple_compotor.style.paddingTop = "unset";
        simple_compotor.style.backgroundColor = "unset";
        simple_compotor.style.marginTop = "unset";
        simple_compotor.style.marginLeft = "unset";
      }

      if (fieldsets_section) {
        fieldsets_section.classList.remove("sticky");
        fieldsets_section.style.top = "unset";
        fieldsets_section.style.backgroundColor = "unset";
        fieldsets_section.style.paddingBottom = "unset";

        if (field_section_28985) {
          field_section_28985.style.marginBottom = "unset";
        }
      }
    }
  }
}
